var map = {
	"./abookapart.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/abookapart.svg",
	"./alistapart.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/alistapart.svg",
	"./aneventapart.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/aneventapart.svg",
	"./bluesky.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/bluesky.svg",
	"./codepen.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/codepen.svg",
	"./facebook.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/facebook.svg",
	"./flickr.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/flickr.svg",
	"./github.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/github.svg",
	"./google-drive.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/google-drive.svg",
	"./instagram.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/instagram.svg",
	"./linkedin.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/linkedin.svg",
	"./mastodon.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/mastodon.svg",
	"./smashingmagazine.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/smashingmagazine.svg",
	"./speakerdeck.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/speakerdeck.svg",
	"./threads.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/threads.svg",
	"./tumblr.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/tumblr.svg",
	"./twitter.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/twitter.svg",
	"./youtube.svg": "./node_modules/@svgr/webpack/dist/index.js!./src/assets/icons/brands/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/brands sync recursive ./!./!./node_modules/@svgr/webpack/dist/index.js!./ \\.svg$";